import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";

import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import HeaderBar from "../components/HeaderBar";
import RGAForm from "./RGAForm";

function Dashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
      <Box>
          <HeaderBar />
          <Stack direction='column' spacing={2}>
              <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                  <Typography variant="h4" gutterBottom>Submit an RGA</Typography>
              </Box>
              <RGAForm />
          </Stack>
      </Box>
  );
}

export default Dashboard;